import { fabric } from "fabric";
import { v4 } from "uuid";

import { CanvasHandler } from "../../handlers";
import { FabricEvent, FabricObject } from "../../types/FabricCustomType";
import { IObjectDesingner } from "../../types/HandlerObjectType";
import TextProperties from "./properties/TextProperties";

class Text extends TextProperties implements IObjectDesingner {
  constructor(CanvasHandler: CanvasHandler) {
    super(CanvasHandler);
  }

  onRotated(event: FabricEvent) {
    throw new Error("Method not implemented.");
  }

  public onInit() {
    this.canvasHandler.interactionHandler.drawing("text", "text");
    this.canvasHandler.activeShape = null;
  }

  onMouseDblClick(event: FabricEvent<Event>) {
    return;
  }

  public onMousedown(event: FabricEvent<MouseEvent>) {
    const { x, y } = this.canvasHandler.canvas.getPointer(event.e);
    this.addPoint(x, y);
  }

  public onMousemove(event: FabricEvent<MouseEvent>) {
    return;
  }

  public onMouseup(event: FabricEvent<MouseEvent>) {
    this.generate(false, false);
    this.finish();
  }

  private addPoint(x: number, y: number) {
    this.canvasHandler.isDown = true;
    const editable = this.canvasHandler.editable;
    const id = v4();
    this.canvasHandler.objText = new fabric.Text("Texto", {
      fontSize: 16,
      fontStyle: "normal",
      left: x,
      top: y,
      angle: 0,
      fill: "#000000",
      stroke: "#727272",
      strokeWidth: 0,
      fontFamily: "Roboto",
      opacity: 1,
      strokeUniform: true,
      type: "text",
      hasControls: editable,
      hasBorders: editable,
      selectable: editable,
      lockMovementX: !editable,
      lockMovementY: !editable,
      hoverCursor: !editable ? "pointer" : "move",
      text: "Texto",
      fontWeight: "bold",
    }) as FabricObject<fabric.IText>;
    this.canvasHandler.objText.set({
      id: id,
      superType: "text",
      container: this.canvasHandler.container.id,
      centerTransform: true,
      checkFontStyle: false,
      checkFontWeight: true,
      checkCenter: false,
      checkRight: false,
      checkLeft: true,
      checkJustify: false
    });

    this.canvasHandler.objText?.setControlsVisibility({
      tl: false, //top-left
      mt: false, // middle-top
      tr: false, //top-right
      ml: false, //middle-left
      mr: false, //middle-right
      bl: false, // bottom-left
      mb: false, //middle-bottom
      br: false, //bottom-right
      mtr: true,
    });

    this.canvasHandler.canvas.add(this.canvasHandler.objText);
    this.canvasHandler.activeShape = this.canvasHandler.objText;
  }

  private generate(isDown: any, loaded: any) {
    const { editable, gridOption, onAdd } = this.canvasHandler;
    const obj = this.canvasHandler.activeShape;
    if (obj === "node") obj.setShadow({ color: obj.stroke });
    if (obj.dblclick)
      obj.on("mousedblclick", this.canvasHandler.eventHandler.object.mousedblclick);
    if (obj.superType === "node") this.canvasHandler.portHandler.create(obj);
    if (gridOption?.enabled ?? false) this.canvasHandler.gridHandler.setCoords(obj);
    if (!this.canvasHandler.transactionHandler.active && !loaded)
      this.canvasHandler.transactionHandler.save("add");
    if (onAdd && editable && !loaded) onAdd(obj);

    this.canvasHandler.isDown = isDown;
    this.canvasHandler.objText = obj;
  }

  private finish() {
    //this.canvasHandler.canvas.remove(this.canvasHandler.activeShape);
    this.canvasHandler.isDown = false;
    this.canvasHandler.objText = null;
    this.canvasHandler.activeShape = null;
    this.canvasHandler.canvas.renderAll();
    this.canvasHandler.interactionHandler.selection();
  }
}

export default Text;
